import React from 'react';
import { AppGridLayout, AppTableSearch, AppSearchItem, AppTable, AppRow, AppButton } from 'qcc';
import { AppAction } from 'qcc';
import api, { MdmProject, ErpProjectOutput } from "api";
import { default as EditForm } from './ProjectEdit';
import ProjectSelectTable from './ProjectSelectTable';

export default class extends React.Component<IPage> {
  state = {}
  add = async (data?: any) => {
    let { dataType, full_code, id, organ_id, parent_id } = data;
    let title = dataType === 'mjgs' ? '新增项目' : '新增分期';
    let formData = { name: '', code: '', organId: organ_id, parentId: id };
    let fullCode = dataType === 'mjgs' ? '' : full_code;
    AppAction.openDialog(<EditForm mode={1} formData={formData} extraData={{ fullCode }} afterSave={this.afterSave} />, { title, width: 600, height: 360 })
  }

  edit = async (data?: any) => {
    console.log('data', data)
    let { dataType, project_parent_code } = data;
    let title = dataType === 'xm' ? '编辑项目' : '编辑分期';
    let formData = await api.mdmproject.getOne({ id: data.id });
    AppAction.openDialog(<EditForm mode={2} formData={formData} id={formData.id.toString()} extraData={{ fullCode: project_parent_code }} afterSave={this.afterSave} />, { title, width: 600, height: 360 })
  }



  delete = async (data?: any) => {
    if (await AppAction.deleteConfirm('您确定要删除该记录吗？')) {
      await api.mdmproject.delete({ id: data.id });
      AppAction.successMsg('删除成功！');
      this.refGrid.current && this.refGrid.current.state.refTable.fetch();
    }
  }

  getErpProjectList = async (data?: any) => {
    AppAction.coverFull();
    let erpProjectOutput = await api.mdmproject.getErpXmList({ organId: data.organ_id }) as ErpProjectOutput[];
    let title = '项目列表';
    let width = 600;
    let height = 600;
    let projectSelectTable = <ProjectSelectTable erpProjectOutput={erpProjectOutput} organId={data.organ_id} afterSave={this.afterSave} />
    AppAction.openDialog(projectSelectTable, {
      title, height, width
    });
    // this.refGrid.current && this.refGrid.current.state.refTable.fetch();
    AppAction.cancelCoverFull();
  }

  afterSave = () => {
    this.refGrid.current && this.refGrid.current.state.refTable.fetch();
    AppAction.closeDialog();
  }

  refGrid = React.createRef<AppGridLayout>();

  renderButton = (data: any) => {
    let { dataType } = data;
    if (dataType === 'mjgs') {
      return <AppRow itemSplit={10} style={{ float: 'right' }}>
        <AppButton type='link' label='同步项目主数据' actionCode="00020104" action={() => this.getErpProjectList(data)} />
        <AppButton type='link' label='新增项目' actionCode="00020101" action={() => this.add(data)} />
      </AppRow>

    } else if (dataType === 'xm') {
      return <AppRow itemSplit={10} style={{ float: 'right' }}>
        <AppButton type='link' label='新增分期' actionCode="00020101" action={() => this.add(data)} />
        <AppButton type='link' label='编辑' actionCode="00020102" action={() => this.edit(data)} />
        <AppButton type='link' label='删除' actionCode="00020103" action={() => this.delete(data)} />
      </AppRow>
    } else if (dataType === 'fq') {
      return <AppRow itemSplit={10} style={{ float: 'right' }}>
        <AppButton type='link' label='编辑' actionCode="00020102" action={() => this.edit(data)} />
        <AppButton type='link' label='删除' actionCode="00020103" action={() => this.delete(data)} />
      </AppRow>
    }
    return null;
  }

  render() {
    return (
      <AppGridLayout ref={this.refGrid}>
        <AppGridLayout.SearchArea>
          <AppTableSearch>
            <AppTableSearch.Common>
              <AppSearchItem.ProjectTree keyName='organId' field='organ_id' opr='organ_collection' lable='公司：' />
            </AppTableSearch.Common>
          </AppTableSearch>
        </AppGridLayout.SearchArea>
        <AppGridLayout.GridArea>
          <AppTable parentKeyName='parent_id' paging={false} onBeforeApi={(data?: any) => { return data.organId !== undefined }} sqlId='sql.mdmProject.gridTree' orderBy='full_code' >
            <AppTable.Col title='公司/项目P码' field='pos_id' width={300} expand />
            <AppTable.Col title='公司/项目' field='name' width={300} expand />
            <AppTable.ColAction render={(data: any, dataIndex: number) => {
              return this.renderButton(data);
            }} />
          </AppTable>
        </AppGridLayout.GridArea>
      </AppGridLayout>
    )
  }
}


// WEBPACK FOOTER //
// ./src/page/mdm/project/index.tsx